export class MobileAppReferer {
  static REFERER_PARAM = 'referer';
  static REFERER_PARAM_VALUE = 'mobile-app';

  static SIGNUP_COMPLETE_LINK = 'agm://web-signup-complete';

  static SIGNUP_COMPLETE_HASH_PARAM = 'hash';
  static SIGNUP_COMPLETE_LOGIN_PARAM = 'login';
  static SIGNUP_COMPLETE_LOGIN_URL_PARAM = 'login-url';

  static createSignupCompleteURL(
    hash: string,
    login: string,
    loginUrl: string
  ): string {
    const url = new URL(MobileAppReferer.SIGNUP_COMPLETE_LINK);

    url.searchParams.set(MobileAppReferer.SIGNUP_COMPLETE_HASH_PARAM, hash);
    url.searchParams.set(MobileAppReferer.SIGNUP_COMPLETE_LOGIN_PARAM, login);
    url.searchParams.set(
      MobileAppReferer.SIGNUP_COMPLETE_LOGIN_URL_PARAM,
      loginUrl
    );

    return url.toString();
  }

  static isCurrentSessionReferedFromMobileApp(): boolean {
    const referer = new URLSearchParams(window.location.search).get('referer');

    return referer === MobileAppReferer.REFERER_PARAM_VALUE;
  }

  static createMobileAppRefererQueryString(): string {
    const searchParams = new URLSearchParams();

    searchParams.set(
      MobileAppReferer.REFERER_PARAM,
      MobileAppReferer.REFERER_PARAM_VALUE
    );

    return searchParams.toString();
  }
}
